import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslatePipe, TranslateDirective} from '@ngx-translate/core';

import {AccordionModule} from 'ngx-bootstrap/accordion';
import {AlertModule} from 'ngx-bootstrap/alert';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {ProgressbarModule} from 'ngx-bootstrap/progressbar';
import {RatingModule} from 'ngx-bootstrap/rating';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {FlexCompatModule} from './flex-compat/flex-compat.module';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';

import {ColorsService} from './colors/colors.service';
import {AppToastService} from './services/util/app-toast.service';
import {UtilityService} from './services/util/utility.service';
import {AuthenticationService} from './services/authentication.service';
import {CryptoService} from './services/crypto.service';

import {CircleComponent} from './spinners/circle/circle.component';
import {CubeGridComponent} from './spinners/cube-grid/cube-grid.component';
import {ChaseComponent} from './spinners/chase/chase.component';

import {ValidateProfilePipe} from './pipes/validate-profile.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    AccordionModule,
    AlertModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    PopoverModule,
    TypeaheadModule,
    FlexCompatModule,
    NgxMatSelectSearchModule
  ],
  providers: [
    ColorsService,
    AppToastService,
    UtilityService,
    AuthenticationService,
    CryptoService,
    DatePipe
  ],
  declarations: [
    CubeGridComponent,
    CircleComponent,
    ChaseComponent,
    ValidateProfilePipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    RouterModule,
    AccordionModule,
    AlertModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    PopoverModule,
    TypeaheadModule,
    FlexCompatModule,
    NgxMatSelectSearchModule,
    CubeGridComponent,
    CircleComponent,
    ChaseComponent,
    ValidateProfilePipe
  ]
})

export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule
    };
  }
}
